import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MyQuotes, MyQuotesState } from './definitions';
import { MyQuotesService } from './my-quotes.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { MyQuotesUtilService } from './my-quotes.util.service';

@Component({
	selector: 'tmhna-portal-my-quotes',
	templateUrl: './template/my-quotes.component.html',
	styleUrls: ['./template/my-quotes.component.scss']
})
export class MyQuotesComponent implements MyQuotes, OnInit 
{
    @Input() set state(value: MyQuotesState) 
	{
		this.service.updateState(value);
	}
    get state(): MyQuotesState 
    {
    	return this.service.state;
    }
  
    @Output() stateChanged: EventEmitter<MyQuotesState> = new EventEmitter<MyQuotesState>();

    constructor( public service: MyQuotesService, private readonly analyticsService: AnalyticsService, public utilService: MyQuotesUtilService) { }

    ngOnInit(): void 
    {
    	this.service.getMyQuotesLabelState();
    	this.analyticsService.trackByEvent({
    		event: 'pageView',
    		page: {
    			name: 'My Quotes'
    		}
    	});
    }
  
}
